import React from 'react';
import TopSection from '../components/TopSection';

const PrivacyPolicy = () => {
    return (
        <>
            <TopSection title='Privacy & Policy' breadcrumb='Privacy & Policy' />
            <div className="container py-5">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-11 col-lg-10">
                        <div className="text-center mb-5">
                            <h1 className="fw-bold">SKY<span className='text-info'>GUARD</span> Privacy Policy</h1>
                            <p className="text-muted">Last updated: September 5, 2025</p>
                        </div>

                        <section className="mb-4">
                            <p>
                                At <strong>Skyguard</strong>, your privacy is our priority. This Privacy Policy
                                outlines how we collect, use, disclose, and protect your personal information when
                                you interact with our website, mobile applications, and services.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">1. Information We Collect</h4>
                            <p>We collect the following types of data to improve your experience:</p>
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item">
                                    <strong>Personal Information:</strong> Name, email, phone number, billing details.
                                </li>
                                <li className="list-group-item">
                                    <strong>Usage Data:</strong> Pages visited, actions taken, and duration.
                                </li>
                                <li className="list-group-item">
                                    <strong>Device Info:</strong> IP address, browser type, operating system.
                                </li>
                                <li className="list-group-item">
                                    <strong>Location Data:</strong> Real-time GPS location if enabled.
                                </li>
                            </ul>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">2. How We Use Your Information</h4>
                            <p>Your data is used to:</p>
                            <div className="row">
                                <div className="col-md-6">
                                    <ul>
                                        <li>Personalize services and recommendations</li>
                                        <li>Enhance user support</li>
                                        <li>Improve platform performance</li>
                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <ul>
                                        <li>Send important updates and alerts</li>
                                        <li>Prevent fraud and secure our systems</li>
                                        <li>Conduct analytics and reporting</li>
                                    </ul>
                                </div>
                            </div>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">3. Sharing Your Information</h4>
                            <p>
                                We do not sell your data. We may share information with trusted third parties under these conditions:
                            </p>
                            <ul className="ps-3">
                                <li><strong>Service Providers:</strong> For payment, analytics, and support services.</li>
                                <li><strong>Legal Compliance:</strong> When legally required or in response to valid requests.</li>
                                <li><strong>Business Transfers:</strong> During company mergers or acquisitions.</li>
                            </ul>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">4. Data Security</h4>
                            <p>
                                We use encryption, secure servers, firewalls, and monitoring to safeguard your data. However, no system is completely secure, so please protect your account credentials.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">5. Your Rights</h4>
                            <p>You have the right to:</p>
                            <ul>
                                <li>Access or update your personal data</li>
                                <li>Request data deletion</li>
                                <li>Restrict or object to data processing</li>
                                <li>Withdraw consent at any time</li>
                                <li>Unsubscribe from marketing communications</li>
                            </ul>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">6. Cookies & Tracking</h4>
                            <p>
                                We use cookies and tracking technologies to enhance functionality and analytics. You can modify cookie preferences in your browser settings.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">7. External Links</h4>
                            <p>
                                Our platform may link to third-party websites. We are not responsible for their privacy policies and encourage you to review them separately.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">8. Children’s Privacy</h4>
                            <p>
                                Skyguard does not knowingly collect data from children under 13. If we learn of any such collection, we will delete it immediately.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">9. Data Retention</h4>
                            <p>
                                We retain data as long as necessary for business, legal, or operational purposes. When no longer needed, we securely delete it.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">10. International Transfers</h4>
                            <p>
                                If you are accessing Skyguard from outside the U.S., your data may be transferred internationally. We ensure protection via standard contractual clauses and data transfer agreements.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">11. Policy Updates</h4>
                            <p>
                                We may update this policy periodically. When we do, we’ll notify you by revising the date or through direct communication.
                            </p>
                        </section>

                        <section className="mb-5">
                            <h4 className="fw-semibold">12. Contact Us</h4>
                            <p>If you have questions or concerns, contact us at:</p>
                            <address>
                                <strong>Email:</strong> <a href="mailto:privacy@skyguard.com">privacy@skyguard.com</a><br />
                                {/* <strong>Phone:</strong> (800) 123-4567<br />
                                <strong>Address:</strong> 123 Sentinel Way, Palo Alto, CA 94301 */}
                            </address>
                        </section>

                        <div className="alert alert-primary text-center mt-5" role="alert">
                            By using our services, you agree to the terms outlined in this Privacy Policy.
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PrivacyPolicy;
